/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

let shortcuts = new Map<string, Function>();
let freeze = false;

export const initialize = () => {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
        if(shortcuts.has(event.key) && !freeze) {
            let target: HTMLElement | null = event.target as HTMLElement;
            let shortcut: Function | undefined = shortcuts.get(event.key);
            if(target !== null && target.tagName.toLowerCase() === "input") {
                return;
            } else if(shortcut !== undefined) {
                shortcut();
            }
        }
    })
}

export const register = (key: string, action: Function) => {
    shortcuts.set(key, action);
}

export const freezeShortcuts = (newFreezeState: boolean) => {
    freeze = newFreezeState;
}
